import { cn } from '@/shared/utils';

type Props = {
  count: number;
  className?: string;
};

export const CountBadge = ({ count, className }: Props) => (
  <span
    className={cn(
      'flex h-[1.6rem] min-w-[1.6rem] shrink-0 items-center justify-center rounded-full bg-destructive px-[0.4rem] font-digits text-[1rem] font-semibold leading-[1.2rem] text-white',
      className
    )}>
    {count}
  </span>
);
